import React from "react";
import { useSwitchingProfile } from "../../hooks";
import { ModernContentPane } from "../components/ContentPane";
import { Header } from "../components/Header";
import { Menu } from "../components/Menu";
import { Spine } from "../components/Spine";
import { SpineProvider } from "../components/Spine/SpineContext";
import { DialogLayer } from "./DialogLayer";
import { LayoutContainer } from "./LayoutContainer";
import { ProfileSwitcher } from "./ProfileSwitcher";
import { ToastContainer } from "./ToastContainer";
import { UIBlocker } from "./UIBlocker";
export const ModernLayout = () => {
    const switchingProfile = useSwitchingProfile();
    return (React.createElement(SpineProvider, null,
        React.createElement(LayoutContainer, { className: "flex h-full bg-surface-base" },
            React.createElement(Spine, null),
            React.createElement("div", { className: "flex min-w-0 grow flex-col" },
                React.createElement(Header, null),
                React.createElement("div", { className: "flex min-h-0 grow" },
                    switchingProfile ? (React.createElement(ProfileSwitcher, null)) : (React.createElement(React.Fragment, null,
                        React.createElement(Menu, null),
                        React.createElement(ModernContentPane, null))),
                    React.createElement(DialogLayer, null),
                    React.createElement(ToastContainer, null)))),
        React.createElement(UIBlocker, null)));
};
